(() => {
  if (!document.getElementById("screensaver")) {
    return false;
  }
  const backButton = document.getElementById("backButton");
  const screensaver = document.getElementById("screensaver");
  const whitescreen = document.getElementById("white-screen");
  const bluescreen = document.getElementById("blue-screen");
  const imageLogo = document.getElementById("imageLogo");
  const flare = document.getElementById("flare");
  const arm = document.getElementById("arm");
  const flare2 = document.getElementById("flare2");
  const arm2 = document.getElementById("arm2");

  function start_screensaver() {
    if (screensaver_state == true) {
      screensaver.classList.remove("translucent");
      var slides = [1, 2, 3, 4, 5, 6];
      var interval = 300;

      slides.forEach(function (el, index) {
        setTimeout(function () {
          var str = document.createElement("div");
          str.className = "white-screen__item";

          whitescreen.appendChild(str);
          clearTimeout();
        }, index * interval);
      });

      setTimeout(function () {
        slides.forEach(function (el, index) {
          setTimeout(function () {
            var str = document.createElement("div");
            str.className = "blue-screen__item";

            bluescreen.appendChild(str);
            clearTimeout();
          }, index * interval);
        });
      }, interval * 6);

      setTimeout(function () {
        var truebackground = document.createElement("div");
        truebackground.className = "truebackground";
        truebackground.id = "truebackground";
        screensaver.append(truebackground);
        slides.forEach(function () {
          var str = document.createElement("div");
          str.className = "truebackground__item";

          truebackground.appendChild(str);
        });

        setTimeout(function () {
          truebackground.append(imageLogo);
          const first = document.querySelector(".truebackground :nth-child(1)");
          const fifth = document.querySelector(".truebackground :nth-child(5)");

          var flareWrapper = document.createElement("div");
          var flareWrapper2 = document.createElement("div");

          flareWrapper.className = "flareWrapper";
          flareWrapper2.className = "flareWrapper2";

          flareWrapper.append(flare);
          flareWrapper.append(arm);
          flareWrapper2.append(flare2);
          flareWrapper2.append(arm2);

          first.append(flareWrapper);
          fifth.append(flareWrapper2);

          imageLogo.classList.remove("hidden");
          flare.classList.remove("hidden");
          arm.classList.remove("hidden");
          flare2.classList.remove("hidden");
          arm2.classList.remove("hidden");
        }, interval);
      }, interval * 6 * 2 + 500);
    }
  }

  function stop_screensaver() {
    screensaver_state = false;
    screensaver.classList.add("translucent");
    const truebackground = document.getElementById("truebackground");

    setTimeout(function () {
      if (truebackground) {
        truebackground.remove();
        while (bluescreen.firstChild) {
          bluescreen.removeChild(bluescreen.lastChild);
        }

        while (whitescreen.firstChild) {
          whitescreen.removeChild(whitescreen.lastChild);
        }
      }
    }, 2000);
  }

  if (typeof backButton != "undefined" && backButton != null) {
    backButton.addEventListener("click", function () {
      screensaver_state = false;
      start_screensaver();
    });
  }

  if (typeof screensaver != "undefined" && screensaver != null) {
    // screensaver

    var screensaver_state = false;
    // var moved = false;
    var idletime = 5;

    document.addEventListener("mousemove", function () {
      const mousetimeout = setTimeout(start_screensaver, 1000 * idletime);
      clearTimeout(mousetimeout);
      stop_screensaver();
    });
  }
})();
